export const apiUrl = "https://api.roshivamerp.com/api/"
// export const apiUrl = "http://localhost:4446/api/"
export const apiConfig = {
  user: "shivam",
  pass: "shivam@V2$2023#",
  key: "827364",
}
